export default __webpack_public_path__ + "static/media/RxLogo.5359c5a8.png";